<div class="container-fluid fluid2 print" style="margin:1rem 0">
    <section class="container-fluid invoice">
        <div class="row containerInier">
            <div class="div_loading" style="width:100%" [hidden]="!loading">
                <div class="my-container">
                    <mat-progress-bar mode="indeterminate" class="detaile"></mat-progress-bar>
                </div>
            </div>
            <div class="row" style="padding:15px">
                <div class="row row4" style="padding-top: 15px;">
                    <div class="col-lg-12">
                        <div class="row">
                            <div class="col-lg-4 col-xs-12 justify " style="padding-top:0px;height:4rem;float: left;">
                                <div class="row justify" style="padding-top: 0px;height:3rem">
                                    <div class="payBox" style="width: 100%;text-align: center;">
                                        <div class="logo1">
                                            <img src="{{ logo }}" alt="logo" class="logo1" width="100px" height="100px">
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-lg-4 col-xs-12 justify" style="text-align: center;padding: 0px !important;">
                                <div class="row justify" style="padding:0px">
                                    <div style="line-height: 28px">
                                        <p><span>شماره صورت حساب:</span> {{ id }} </p>
                                        <p><span>تاریخ پذیرش:</span> {{ date }} ({{ date2 }})</p>
                                        <p style="display: none;"><span>تاریخ تحویل:</span> {{ date_ad }} ( {{
                                            date2_ad
                                            }} )
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4 col-xs-12 justify status-title"
                                style="text-align: center;padding:0.5rem;;font-size: large;">
                                <div class="row justify" style="padding-top: 0px;">
                                    <div class="payBox">
                                        <div>
                                            <span class="status_title" [ngClass]="{green:rstatus_empty_shelf == true }">
                                                <span *ngIf="status_id == 3">رسید دریافت دستگاه</span>
                                                <span *ngIf="status_id != 3">{{ status_title }}</span>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="divider"></div>

                <div class="row row2">
                    <div class="col-lg-12">
                        <div class="row">
                            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-12 home-div6">
                                <div class=" row justify">
                                    <div class="details">
                                        <h3 class="h3">مشخصات مشتری</h3>
                                        <address class="smallText">
                                            <div *ngIf="user_title" class="home-div3">{{ sex_title }} {{ user_title }}
                                            </div>
                                            <div *ngIf="user_address" class="home-div3">{{ user_address }}</div>
                                            <div *ngIf="user_cellphone" class="home-div3">{{ user_cellphone }}</div>
                                            <div *ngIf="user_phone" class="home-div3">{{ user_phone }}</div>
                                        </address>
                                    </div>
                                </div>
                            </div>

                            <div class="divider divider1"></div>

                            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                <div class="row justify home-div4" style="padding-top:0.2rem">
                                    <div class="details" style="margin-top:0px !important">
                                        <h3 class="h3">مشخصات فروشنده</h3>
                                        <address class="smallText">
                                            <div class="home-div3">{{ store_title }}</div>
                                            <div class="home-div3" style="line-height:2rem;font-size: 0.9rem;">
                                                {{ store_address }}
                                            </div>
                                            <div *ngIf="store_phone" class="home-div3" style="line-height:2rem">
                                                {{ store_phone }}
                                            </div>
                                        </address>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                <!-- *******************************************************برای گوشی***************************************************** -->

                <div class="row row3">
                    <div class="invoice3"><span>مشخصات فروشنده :</span></div>
                </div>
                <div class="row row3">
                    <div class="col-sm-12 invoice1">
                        <div> نام شرکت : {{ store_title }} </div>
                        <div> آدرس : {{ store_address }} </div>
                        <div> شماره تماس : {{ store_phone }} </div>
                    </div>
                </div>

                <div class="row row3">
                    <div class="invoice3"><span>مشخصات مشتری :</span></div>
                </div>
                <div class="row row3">
                    <div class="col-sm-12 invoice1">
                        <div> نام مشتری : {{ sex_title }} {{ user_title }} </div>
                        <div> آدرس : {{ user_address }} </div>
                        <div> شماره همراه : {{ user_cellphone }} </div>
                        <div> شماره تماس : {{ user_phone }} </div>
                    </div>
                </div>
                <div class="row row3" *ngIf="list_material.length > 0">
                    <div class="invoice3"><span>شرح کالا : </span></div>
                    <div class="col-sm-12 invoice1" *ngFor="let x of list_material">
                        <div>عنوان کالا :
                            {{ x.wharehouse_material_title }}

                            <span *ngIf="x.wharehouse_material_cate_title" class="cate" [hidden]="true"> - {{
                                x.wharehouse_material_cate_title }}
                            </span>
                            <span *ngIf="x.wharehouse_material_cate2_title" class="cate" [hidden]="true">{{
                                x.wharehouse_material_cate2_title }} -
                            </span>

                            <span style="color: #bb2366;" *ngIf="x.comment">{{ x.comment }}</span>
                        </div>

                        <div>مقدار : {{ x.wharehouse_order_number | number}} عدد</div>
                        <div>قیمت واحد به تومان : {{ x.wharehouse_order_cost | number }} </div>
                        <div> قیمت کل به تومان بدون تخفیف : {{ x.sum_all | number }} </div>
                        <div> تخفیف به تومان : {{ x.wharehouse_order_discount | number }} </div>
                        <div> قیمت نهایی به تومان با تخفیف : {{ x.sum_final | number }} </div>
                    </div>
                    <div class="col-sm-12 invoice2">
                        قیمت نهایی فاکتور به تومان : <span style="background-color: #8DF178">{{ sum_final | number
                            }}</span>
                    </div>
                </div>
                <!-- ************************************************************************************************************ -->
                <div class="row row2" *ngIf="list_material.length > 0">
                    <div class="col-lg-12">
                        <div class="row">
                            <table class="table table-condensed">
                                <thead>
                                    <tr>
                                        <td class="borderLeft headBg"><span class="th-header">شرح کالا</span></td>
                                        <td class="text-center borderLeft headBg"><span class="th-header">مقدار</span>
                                        </td>
                                        <td class="text-center borderLeft headBg"><span class="th-header">قیمت واحد به
                                                تومان</span>
                                        <td class="text-center borderLeft headBg"><span class="th-header">قیمت کل به
                                                تومان
                                                بدون تخفیف</span>
                                        </td>
                                        <td class="text-center borderLeft headBg"><span class="th-header">تخفیف به
                                                تومان</span>
                                        </td>
                                        <td class="text-center borderLeft headBg"><span class="th-header">قیمت به
                                                تومان با تخفیف</span>
                                        </td>
                                        <td class="text-center borderLeft headBg"><span class="th-header">ارزش افزوده به
                                                تومان</span>
                                        </td>
                                        <td class="text-center borderLeft headBg"><span class="th-header">قیمت نهایی به
                                                تومان با تخفیف</span>
                                        </td>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let x of list_material">
                                        <td class="borderLeft">
                                            {{ x.wharehouse_material_title }}
                                            <span *ngIf="x.wharehouse_material_cate_title" class="cate" [hidden]="true">
                                                - {{
                                                x.wharehouse_material_cate_title}} -
                                            </span>
                                            <span *ngIf="x.wharehouse_material_cate2_title" class="cate"
                                                [hidden]="true"> {{
                                                x.wharehouse_material_cate2_title }} </span>

                                            <div style="font-size: 0.8rem;">
                                                <span style="color: #bb2366;">{{ x.comment }}</span>
                                            </div>
                                        </td>
                                        <td class="text-center borderLeft">{{ x.wharehouse_order_number | number }}</td>
                                        <td class="text-center borderLeft">{{ x.wharehouse_order_cost | number }}
                                        <td class="text-center borderLeft">{{ x.sum_all | number }}
                                        <td class="text-center borderLeft">{{ x.wharehouse_order_discount | number }}
                                        <td class="text-center borderLeft">{{ x.sum_with_discount | number }} </td>

                                        <td class="text-center borderLeft">{{ x.tax | number }}
                                        </td>
                                        <td class="text-center borderLeft">{{ x.sum_final | number }} </td>
                                    </tr>
                                    <tr style="background-color: #E8F5E9;">
                                        <td class="textRight borderLeft">
                                        </td>
                                        <td class="text-center borderLeft"></td>
                                        <td class="text-center borderLeft"></td>
                                        <td class="text-center borderLeft">{{ sum_all | number }}</td>
                                        <td class="text-center borderLeft">{{ discount_all | number }}</td>
                                        <td class="text-center borderLeft"><span>{{ sum_with_discount | number }}</span>
                                        </td>
                                        <td class="text-center borderLeft"><span>{{ sum_tax | number }}</span></td>
                                        <td class="text-center borderLeft">
                                            <span>قیمت نهایی </span>
                                            <span style="background-color: #8DF178">{{ sum_final | number }}</span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <!-- ************************************************************************************************************ -->
                <div class="row row1">
                    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 sign_div">

                        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-12" style="min-height:6rem">
                            <div class="col-lg-12 sign_div2">مهر و امضای
                                <span>
                                    مشتری
                                    {{ sex_title }} {{ user_title }}
                                </span>
                            </div>
                        </div>

                        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-12" style="min-height:6rem">

                        </div>

                    </div>
                </div>

                <div class="row">
                    <div class="rule">
                        {{ rule_site }}
                    </div>
                </div>
            </div>
            <footer class="container-fluid footer">

                <div class="row">
                    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <span class="noprint" style="float: left;">
                            <a href="javascript:window.print()" class="btn btn-default print-button"><i
                                    class="icon-printer"></i> پرینت</a>
                        </span>
                        <span class="footer"> {{ footer }} </span>
                    </div>
                </div>
            </footer>
        </div>



    </section>
</div>
<br>